import { IApiConfig, NETWORK_CALL_FAILED, PersonId } from "@hopper-b2b/types";
import { airBookingApi, AnyResponse } from "@b2bportal/air-booking-api";
import { axiosInstance } from "../AxiosInterceptor";
import { trackEvent } from "../tracking/trackEvent";

export const deleteUserPassenger = (
  body: IDeleteUserPassengerRequest,
  apiConfig?: IApiConfig
): Promise<AnyResponse> =>
  new Promise((resolve, reject) => {
    airBookingApi(axiosInstance)
      .apiV0FlightPassengersDeletePost(body)
      .then((res) => {
        const responseBody: AnyResponse = res.data;
        resolve(responseBody);
      })
      .catch((e) => {
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
            },
          },
          apiConfig
        );
        reject(e);
      });
  });

export interface IDeleteUserPassengerRequest {
  personId: PersonId;
}
